import { type Route } from '@angular/router';

import { aiAccessGuard } from './core/auth/ai-access.guard';
import { authGuard } from './core/auth/auth.guard';
import { MainLayoutComponent } from './layout/main/main.component';

export const appRoutes: Route[] = [
  {
    loadChildren: () => import('./features/auth/auth.routes'),
    path: 'auth',
  },
  {
    children: [
      {
        loadChildren: () => import('./features/profile/profile.routes'),
        path: 'profile',
      },
      {
        canActivate: [aiAccessGuard],
        loadChildren: () => import('./features/dashboard/dashboard.routes'),
        path: 'dashboard',
      },
      {
        canActivate: [aiAccessGuard],
        loadChildren: () => import('./features/workspace/workspace.routes'),
        path: 'workspace',
      },
      {
        canActivate: [aiAccessGuard],
        loadChildren: () => import('./features/library/library.routes'),
        path: 'library',
      },
      {
        canActivate: [aiAccessGuard],
        loadChildren: () => import('./features/practice/practice.routes'),
        path: 'practice',
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'workspace',
      },
    ],
    canActivate: [authGuard],
    component: MainLayoutComponent,
    path: '',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'workspace',
  },
  {
    path: '**',
    redirectTo: 'workspace',
  },
];
